export default {
	inProcessDev: `Էջը կառուցման փուլում է: <br/> Շուտով դուք կկարողանաք օգտագործել դրա բոլոր գործառույթները: <br/> <strong> Շնորհակալություն ըմբռնման համար </strong>`,
}